import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSession } from "../hooks/useSession";
import {
  commonAnalyticsAPI,
  EVENT_TYPES,
  getIsAuthenticated,
  maintenanceStatus,
} from "./constants";

const PrivateRoute = ({ children }) => {
  const { session, loading, error } = useSession();
  const location = useLocation();

  const maintenance = useSelector((state) => state.common.maintenance);

  const isAuthenticated = getIsAuthenticated(session);

  useEffect(() => {
    if (isAuthenticated) {
      handleCloseEvent();
    }
  }, [isAuthenticated]);

  const handleCloseEvent = async () => {
    const keys = [];

    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith("sn_mapp_")) keys.push(k);
    }

    for (const key of keys) {
      try {
        const raw = localStorage.getItem(key);
        if (!raw) continue;

        const localData = JSON.parse(raw);
        if (!localData?.app_id || !localData?.app_name || !localData?.session) {
          continue;
        }

        await commonAnalyticsAPI({
          data: { id: localData.app_id, display_name: localData.app_name },
          type: EVENT_TYPES.CLOSE,
          session: localData.session,
          closeTime: localData?.close_time ?? Date.now(),
        });
        localStorage.removeItem(key);
      } catch (e) {
        console.warn("Failed to flush CLOSE analytics:", key, e);
      }
    }
  };

  if (loading) {
    return null;
  }
  if (error) {
    return <Navigate to="/" replace />;
  }

  if (
    maintenance?.status?.toLowerCase() ===
      maintenanceStatus?.under_maintenance &&
    location?.pathname !== "/under-maintenance"
  ) {
    return <Navigate to="/under-maintenance" replace />;
  }

  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
